import { safe, ErrorADT } from "pb.safe";

import type { Route } from "../app/routes/shared/route";
import { logger } from "../shared/logger";
import { auth0Config, TokenResponseSchema } from "./shared/auth0";

/**
 * Refreshes configuration tokens.
 */
export async function refreshTokens(
	tokens: Partial<Route.Tokens> | undefined,
): Promise<
	| Route.Tokens
	| ErrorADT<
			"TokensInvalid" | "AccessTokenInvalid" | "RefreshTokenExchangeFailed"
	  >
> {
	const { authAccessToken, authRefreshToken, authIdToken } = tokens ?? {};

	if (!(authAccessToken && authRefreshToken && authIdToken)) {
		logger.warn("refresh tokens: invalid tokens configuration");

		return ErrorADT("TokensInvalid");
	}

	logger.info("refresh tokens: refreshing access token");

	const tokenResponse = await safe(() =>
		fetch(`https://${auth0Config.domain}/oauth/token`, {
			method: "POST",
			body: new URLSearchParams({
				grant_type: "refresh_token",
				client_id: auth0Config.clientId,
				refresh_token: authRefreshToken,
			}),
		})
			.then((response) => response.json())
			.then((body) => TokenResponseSchema.parse(body)),
	);

	if (tokenResponse instanceof Error) {
		logger.error("refresh tokens: refreshing access token failed", {
			message: tokenResponse.message,
			cause: tokenResponse.cause,
		});
		return ErrorADT("RefreshTokenExchangeFailed");
	}

	return {
		authAccessToken: tokenResponse.access_token,
		authRefreshToken: tokenResponse.refresh_token,
		authIdToken: tokenResponse.id_token,
	};
}
